import Vue from 'vue'

export default async () => {
  const VueDOMPurifyHTML = (await import('vue-dompurify-html')).default
  Vue.use(VueDOMPurifyHTML)
}
